let officeJsUnavailable = false;
let bypassOfficeJsApi: boolean | null = false;
let bypassFlagReader: (() => boolean) | null = null;

export function registerOfficeJsBypassFlagReader(reader: (() => boolean) | null): void {
  bypassFlagReader = reader;
}

export function markOfficeJsUnavailable(): void {
  officeJsUnavailable = true;
}

export function setOfficeJsBypassFlag(value: boolean): void {
  bypassOfficeJsApi = value;
}

export function resetOfficeJsBypassFlag(): void {
  bypassOfficeJsApi = false;
}

export function invalidateOfficeJsBypassFlag(): void {
  bypassOfficeJsApi = null;
}

export function isOfficeJsBypassed(): boolean {
  if (officeJsUnavailable) {
    return true;
  }
  if (bypassFlagReader) {
    return bypassFlagReader();
  }
  return bypassOfficeJsApi === true;
}
